import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";
import {CategoryInputOutput} from "./category-input-output";

@JsonObject("CategoryGroupDetailOutput")
export class CategoryGroupDetailOutput {
    @JsonProperty()
    public slug: string = JsonPropertyEmpty;

    @JsonProperty()
    public label: string = JsonPropertyEmpty;

    @JsonProperty()
    public categories: CategoryInputOutput[] = JsonPropertyEmpty;

    public constructor(args?: Partial<CategoryGroupDetailOutput>) {
        Object.assign(this, args);
    }
}
